import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  LibrarySelect,
  librarySelector,
  setLibrary,
} from 'features/classCreation';
import styles from './ScheduleLibrarySelect.module.scss';

function ScheduleLibrarySelect() {
  const dispatch = useDispatch();
  const library = useSelector(librarySelector);

  const handleChange = useCallback(
    (value) => {
      dispatch(setLibrary(value));
    },
    [dispatch]
  );

  return (
    <LibrarySelect
      className={styles.root}
      value={library}
      onChange={handleChange}
    />
  );
}

export default ScheduleLibrarySelect;
